import { useEntityDetailsDataStore } from '../use-entity-details-data-store';

export const useResetEntityData = () => {
  const resetEntityData = useEntityDetailsDataStore((state) => state.reset);
  return resetEntityData;
};
